const API_V1 = '/api/v1/';

export enum ApiEndpoints {
  RESET_PASSWORD = `${API_V1}staff/reset-password`,
  VERIFY_RESET_TOKEN = `${API_V1}staff/verify-reset-token`,
  VERIFY_TOTP = `${API_V1}staff/verify-2fa`,
  ENABLE_2FA = `${API_V1}staff/enable-2fa`,
  CONFIRM_2FA = `${API_V1}staff/confirm-2fa`,
  DISABLE_2FA = `${API_V1}staff/disable-2fa`,
  SIGN_UP = `${API_V1}admins/sign-up`,
  LOGIN = `${API_V1}staff/log-in`,
  LOGOUT = `${API_V1}staff/log-out`,
  REFRESH = `${API_V1}staff/refresh-token`,
  GET_COUNTRIES = `${API_V1}countries`,
  GET_CUSTOMERS = `${API_V1}customers`,
  POST_ORDERS = `${API_V1}orders`,
  DELETE_CUSTOMERS = `${API_V1}customers`,
  CREATE_CUSTOMERS = `${API_V1}customers/create`,
  POST_CUSTOMER = `${API_V1}customers/sign-up`,
  GET_ORDERS = `${API_V1}orders`,
  EDIT_ORDER_STATUS = `${API_V1}orders/status`,
  PRINT_ORDER = `${API_V1}orders/print`,
  GET_ORDERS_HISTORY = `${API_V1}orders/history`,
  GET_STAFF = `${API_V1}staff?PageNumber=1&PageSize=10`,
  GET_USER = `${API_V1}staff`,
  SAVE_USER = `${API_V1}staff/get-user`,
  CHANGE_PASSWORD = `${API_V1}staff/change-password`,
  GET_ACTIVE_SESSIONS = `${API_V1}sessions`,
  DELETE_SESSION = `${API_V1}sessions/`,
  DELETE_ALL_SESSIONS = `${API_V1}sessions/terminate-all-sessions`,
  SHOPS = `${API_V1}shops`,
  GET_ROLES = `${API_V1}roles`,
  GET_ROLES_WITH_PERMISSIONS = `${API_V1}roles/get-roles-with-permissions`,
  GET_ALL_ROLES = `${API_V1}roles/all`,
  CATEGORIES = `${API_V1}categories`,
  CATEGORIES_SEARCH = `${API_V1}categories/section/search`,
  GET_CATEGORY_PRODUCT_STATUSES = `${API_V1}categories/get-category-product-statuses`,
  INVENTORY_ITEMS = `${API_V1}inventory-items`,
  INVENTORY_CSV_FILE = `${API_V1}inventory-items/csv-file`,
  GET_INVENTORY_ITEMS = `${API_V1}inventory-items/getinventoryitems`,
  GET_PERSONAL_INFORMATION = `${API_V1}staff/personal-information`,
  GET_BRANDS = `${API_V1}brands`,
  POST_BRANDS = `${API_V1}brands`,
  TOGGLE_ONBOARDING_STATUS = `${API_V1}staff/toggle-onboarding-status?IsOnboardingCompleted`,
  SEARCH_INVENTORY_ITEMS = `${API_V1}inventory-items/getinventoryitems?UpcOrName=`,
  GET_COMMUNICATION_PREFERENCE = `${API_V1}staff/communication-preference`,
  PUT_COMMUNICATION_PREFERENCE = `${API_V1}staff/update-communication-preference`,
  GET_SAS_TOKEN = `${API_V1}azure/sas`,
  GET_CONTENT_FOR_SHOP = `${API_V1}content/`,
  PUT_CHANGE_SUBSCRIPTION = `${API_V1}subscription`,
  GET_SUBSCRIPTION_PANS = `${API_V1}subscription/plans`,
  BASE_PAYMENT_CARDS = `${API_V1}payments`,
  POST_LOCK = `${API_V1}locks/lock`,
  PUT_REFRESH_LOCK = `${API_V1}locks/refresh`,
  DELETE_LOCK = `${API_V1}locks`,
  POST_CHECK_LOCK = `${API_V1}locks/check`,
  FEEDBACK = `${API_V1}/feedbacks`,
  ADD_PAYMENT_METHOD = `${API_V1}/payments`,
}
